import styled from '@emotion/styled'

import { Dialog } from './Dialog'
import { theme } from '../../constants'
import { Paper, PaperProps } from '../Paper'

type CloseButtonDialogBodyProps = Omit<PaperProps, 'as'>

const StyledClose = styled(Dialog.Close)`
  position: absolute;
  top: ${theme.spacing['4'] - 8}px;
  right: ${theme.spacing['4'] - 8}px;
  padding: 2px;
`

export const CloseButtonDialogBody = ({
  children,
  styles = {},
  ...paperProps
}: CloseButtonDialogBodyProps) => {
  const stylesWithDefaults = {
    position: 'relative',
    p: 4,
    width: '100%',
    maxWidth: 600,
    ...styles,
  } as const

  return (
    <Paper as={Dialog.Panel} {...paperProps} styles={stylesWithDefaults}>
      {children}
      {/* Close button is put last in the DOM, so will be the last thing tabbed to */}
      <StyledClose />
    </Paper>
  )
}
